import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToolsService } from "../services/migrate/tools.service";
import {
  STORAGE_KEY_ACCESS_TOKEN_KEYCLOAK,
  STORAGE_KEY_ACCESS_TOKEN_WSO2,
} from "../storageCore/constStorageKeys";
import storageX from "../storageCore/storageX";
import { PageableTerminal } from "./model/ListaTerminal";

const API = "/ms-setera-api/v1/terminal-mensagem-processada/lista";

@Injectable({ providedIn: "root" })
export class ListaTerminalService {
  constructor(private http: HttpClient, private tools: ToolsService) {}

  private buildRequestHeaders(): HttpHeaders {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/json; charset=utf-8")
      .set(
        "Authorization",
        "Bearer " + storageX.whereKeyIs(STORAGE_KEY_ACCESS_TOKEN_WSO2).get()
      );
    const keycloakToken = storageX
      .whereKeyIs(STORAGE_KEY_ACCESS_TOKEN_KEYCLOAK)
      .get();
    if (keycloakToken) {
      headers = headers.set("kc-auth", "Bearer " + keycloakToken);
    }
    return headers;
  }

  public getMensagensTerminais(page: Number) {
    let params = new HttpParams();
    params = params.append("page", page.toString());
    params = params.append("size", "20");
    params = params.append("idTerminal", "0");

    return this.http.get<PageableTerminal>(
      this.tools.builder().api.getApiUrl().api + API,
      { params: params, headers: this.buildRequestHeaders() }
    );
  }

  public getMensagensTerminaisByMensagem(page: Number, mensagem: string) {
    let params = new HttpParams();
    params = params.append("page", page.toString());
    params = params.append("size", "20");
    params = params.append("idTerminal", "0");
    params = params.append("mensagem", mensagem);

    return this.http.get<PageableTerminal>(
      this.tools.builder().api.getApiUrl().api + API,
      { params: params, headers: this.buildRequestHeaders() }
    );
  }

  public getMensagensTerminaisByIdTerminal(page: Number, idTerminal: Number) {
    let params = new HttpParams();
    params = params.append("page", page.toString());
    params = params.append("size", "20");
    params = params.append("idTerminal", idTerminal.toString());
    params = params.append("buscaById", "true");

    return this.http.get<PageableTerminal>(
      this.tools.builder().api.getApiUrl().api + API,
      { params: params, headers: this.buildRequestHeaders() }
    );
  }

  public getMensagensTerminaisByMensagemAndIdTerminal(
    page: Number,
    idTerminal: Number,
    mensagem: string
  ) {
    let params = new HttpParams();
    params = params.append("page", page.toString());
    params = params.append("size", "20");
    params = params.append("idTerminal", idTerminal.toString());
    params = params.append("buscaById", "true");
    params = params.append("mensagem", mensagem);

    return this.http.get<PageableTerminal>(
      this.tools.builder().api.getApiUrl().api + API,
      { params: params, headers: this.buildRequestHeaders() }
    );
  }
}
